import './MobileFrame.css'

import clsx from 'clsx'

import { Iphone14ProHead } from './Iphone14ProHead'

type MobileFrameProps = {
  landscape?: boolean
  scale: number
  bgColor?: string
  statusBarColor: string | number
  children: React.ReactNode
  withSearch?: boolean
  deviceRef: React.RefObject<HTMLDivElement>
}

export const MobileFrame = ({
  landscape,
  scale,
  bgColor,
  statusBarColor,
  withSearch,
  children,
  deviceRef,
}: MobileFrameProps) => {
  return (
    <div className='wrapper-mobile'>
      <div className={clsx('mk-frame mk-frame-mobile iphone-14-pro', landscape ? 'landscape' : 'portrait')}>
        <div className='device-frame-mobile'>
          <div
            className='device-screen-mobile'
            style={{
              position: 'relative',
              background: `var(--color-${bgColor})`,
            }}
          >
            <div
              className={clsx('device-header-mobile', landscape && 'hidden')}
              style={{
                background: `var(--color-${statusBarColor})`,
              }}
            >
              <Iphone14ProHead style={{ width: '100%' }} fill={`var(--color-on-${statusBarColor})`} />
            </div>

            <div className={clsx('device-viewport-mobile', withSearch && 'search-bar')} ref={deviceRef}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
